import { Injectable } from '@angular/core';
import { SICallTypes } from 'src/app/features/service-insights/types/service-insight-types';

@Injectable({
  providedIn: 'root'
})
export class MetricsService {

  constructor() { }

  /**
   * @deprecated Use the @see serviceCallTypeLabel pipe instead since its only purpose is to map SICallTypes to their display labels.
   * Get the unit mapped for the given SICallTypes enum.
   * The unit is just the non-plural form of the SICallType, e.g. 'Installation' for SICallTypes.Installations.
   * @param key
   * @returns
   */
  mapServiceCallKeyToUnit(key: SICallTypes) {
    let value = '';

    switch (key){
      case SICallTypes.ExtraServiceVisit:
        value = 'Extra Service Visit';
        break;
      case SICallTypes.TrainingSessions:
        value = 'Training';
        break;
      case SICallTypes.RegularServiceCalls:
        value = 'Regular Service Call';
        break;
      case SICallTypes.ProgramReviews:
        value = 'Program Review';
        break;
      case SICallTypes.Installations:
        value = 'Installation';
        break;
      case SICallTypes.QuickCalls:
        value = "Quick Calls";
        break;
      case SICallTypes.Audit:
        value = "Audit";
        break;

    }
    return value
  }

  /**
   * Given a string representation of a call type, map it to the corresponding SICallTypes enum.
   * This is needed because the service-details-calls component's inputs come from the URL route,
   * as opposed to an Angular Input property.
   * @param key
   * @returns
   */
  mapCallTypesToKey(key: string | undefined): SICallTypes {
    let value = SICallTypes.UntrackedCalls;
    switch (key){
      case "Extra Service Visits":
      case "Extra Service Requests":
        value = SICallTypes.ExtraServiceVisit;
        break;
      case "Training Sessions":
        value = SICallTypes.TrainingSessions;
        break;
      case "Regular Service Calls":
        value = SICallTypes.RegularServiceCalls;
        break;
      case "Program Reviews":
        value = SICallTypes.ProgramReviews;
        break;
      case "Installations":
        value = SICallTypes.Installations;
        break;
      case "Quick Calls":
        value = SICallTypes.QuickCalls;
        break;
      case "Photo Observations":
        value = SICallTypes.PhotoObservations;
        break;
      case "Virtual Assist Calls":
        value = SICallTypes.VirtualAssistCalls;
        break;
      case "Audits":
        value = SICallTypes.Audit;
        break;
    }
    return value;
  }

}
